import { render, staticRenderFns } from "./levantamentoLista.vue?vue&type=template&id=00b33a64&scoped=true"
import script from "./levantamentoLista.vue?vue&type=script&lang=js"
export * from "./levantamentoLista.vue?vue&type=script&lang=js"
import style0 from "./levantamentoLista.vue?vue&type=style&index=0&id=00b33a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b33a64",
  null
  
)

export default component.exports